window.Tags = {

    // Overlay related items
    overlay     : document.querySelector("[data-js='tags']"), // The tags overlay
    buttonOpen  : document.querySelector("[data-js='tags-open']"), // Tags open button
    buttonClose : document.querySelector("[data-js='tags-close']"), // Tags close button

    // Filter items
    buttons : document.querySelectorAll('[data-js="tag"]'),
    items   : document.querySelectorAll('.list-item,.grid-item,.shop-item'),
    active  : 0,

    // Let's launch this thing
    liftoff : () => {
        Tags.showHideOverlay()
        Tags.onClickFilterTheContent()
    },

    // Show/Hide Overlay
    showHideOverlay : () => {
        
        Tags.overlay.addEventListener('click' , (event) => {
            if (event.target == Tags.overlay) {
                Tags.overlay.close();
            } 
        });

        // "Show the dialog" button opens the dialog modally
        Tags.buttonOpen.addEventListener("click", () => {
            Tags.overlay.showModal();
        });

        // "Close" button closes the dialog
        Tags.buttonClose.addEventListener("click", (event) => {
            event.preventDefault();
            Tags.overlay.close();
        });

    },

    // Filter the content when a tag is clicked
    onClickFilterTheContent : () => {

        // Event is attached to each button
        Tags.buttons.forEach(tag => {

            // It's a click event so we'll register that
            tag.addEventListener('click' , () => {

                // Grab target and status
                let isAnActiveTag = tag.classList.contains('is-active')
                let target        = tag.value

                // Grab the matching tag
                let matching = (tag.classList.contains('sidebar-tag')) ? document.querySelector(`.modal-tag[value="${target}"]`) : document.querySelector(`.sidebar-tag[value="${target}"]`)

                // We need to update the active counter
                Tags.active = (isAnActiveTag) ? Math.max(0,Tags.active - 1) : Tags.active + 1;

                // Toggle the classes
                tag.classList.toggle('is-active')

                // if there's a matching tag toggle that one as well
                if (matching) { matching.classList.toggle('is-active') }

                // First we need to check if there are active tags
                if (Tags.active > 0 && !document.body.classList.contains('tags-are-active'))
                    document.body.classList.add('tags-are-active')

                // First we need to check if there are active tags
                if (Tags.active == 0 && document.body.classList.contains('tags-are-active'))
                    document.body.classList.remove('tags-are-active')


                // Now time to actually filter the items
                if (Tags.active < 1) {
                    document.querySelectorAll('a.stay-visible').forEach(item => { item.classList.remove('stay-visible') })
                    return;
                }

                // Grab all the active tags
                let activeTags          = [...document.querySelectorAll('.modal-tag.is-active')]
                let activeTagsValues    = activeTags.map(btn => `.tag-${btn.value}`);
                let activeTagsAsClasses = activeTagsValues.join(',')

                // We need to grab all the items with the appropriate class
                let matchingItems = document.querySelectorAll(activeTagsAsClasses)

                // Add a class to the matching items
                //Tags.items.forEach(item => { item.classList.add('is-hidden') })
                matchingItems.forEach(item => { item.classList.add('stay-visible') })

            });

        })
    }

};

Tags.liftoff()